import { useLanguage } from "@web/lib/contexts/language-context"
import { Card, CardContent, CardHeader, CardTitle } from "@web/components/ui/card"
import { Separator } from "@web/components/ui/separator"

export function TermsOfUsagePage() {
  const { t } = useLanguage()
  const tu = t.termsOfUsagePage

  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <Card className="shadow-lg">

          <CardHeader className="text-center">

            <CardTitle className="text-2xl font-bold text-foreground sm:text-3xl">
              {tu.title}
            </CardTitle>

            <p className="mt-2 text-lg text-muted-foreground">
              {tu.subtitle}
            </p>
          </CardHeader>

          <CardContent className="space-y-8">
            <section className="space-y-4">
              <p className="text-foreground leading-relaxed">
                {tu.introP1}{" "}
                <a
                  href="https://validainstrumento.com.br/"
                  className="text-primary underline hover:text-primary/80"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://validainstrumento.com.br/
                </a>
                {tu.introP1End}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.introP2}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.introP3}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.introP4}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.introP5}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">

              <h2 className="text-xl font-semibold text-foreground">
                {tu.section1.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section1.p1}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section1.p2}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section1.p3}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section1.p4}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section1.p5}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section2.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section2.p1}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section3.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section3.p1}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section3.p2}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section4.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section4.p1}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section4.p2}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section5.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p1}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p2}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p3}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p4}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p5}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p6}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p7}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section5.p8}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section6.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section6.p1}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section6.p2}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section6.p3}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section6.p4}
              </p>

              <p className="text-foreground leading-relaxed">
                {tu.section6.p5}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section7.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section7.p1}
              </p>
            </section>

            <Separator />

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">
                {tu.section8.title}
              </h2>

              <p className="text-foreground leading-relaxed">
                {tu.section8.p1}
              </p>
            </section>

            <div className="pt-8 text-center text-sm text-muted-foreground">
              <p>{tu.copyright.replace("{year}", String(new Date().getFullYear()))}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </main>
  )
}
